export const MAX_TICKETS_PER_ACCOUNT_PER_EVENT = 4;

export const PURCHASE_LIMIT_MESSAGE =
  "You can buy up to 4 tickets per account for this event.";

function quantityFromSelectedTickets(selectedTickets) {
  if (!Array.isArray(selectedTickets)) return 0;

  return selectedTickets.reduce((sum, group) => {
    const quantity = Number(group?.quantity);
    if (Number.isFinite(quantity) && quantity > 0) return sum + quantity;
    const seatCount = Array.isArray(group?.seat_labels) ? group.seat_labels.length : 0;
    return sum + seatCount;
  }, 0);
}

function isPaidTicketKind(kind) {
  const normalized = String(kind || "paid").trim().toLowerCase();
  return normalized === "paid" || normalized === "";
}

function missingColumnError(error, column) {
  const code = String(error?.code || "");
  const message = String(error?.message || "").toLowerCase();
  return code === "42703" || message.includes(String(column || "").toLowerCase());
}

export async function fetchAccountPurchaseQuota(supabase, { userId, eventId } = {}) {
  const empty = {
    paidCount: 0,
    pendingCount: 0,
    remaining: MAX_TICKETS_PER_ACCOUNT_PER_EVENT,
  };

  if (!supabase || !userId || !eventId) return empty;

  const { data: tiers, error: tierError } = await supabase
    .from("ticket_tiers")
    .select("id")
    .eq("event_id", eventId);

  if (tierError) throw tierError;

  const tierIds = (tiers || []).map((tier) => tier.id).filter(Boolean);
  let paidCount = 0;

  if (tierIds.length) {
    let ticketsResult = await supabase
      .from("tickets")
      .select("id, ticket_kind")
      .eq("buyer_id", userId)
      .in("ticket_tier_id", tierIds);

    if (ticketsResult.error && missingColumnError(ticketsResult.error, "ticket_kind")) {
      ticketsResult = await supabase
        .from("tickets")
        .select("id")
        .eq("buyer_id", userId)
        .in("ticket_tier_id", tierIds);
    }

    if (ticketsResult.error) throw ticketsResult.error;

    paidCount = (ticketsResult.data || []).filter((ticket) => isPaidTicketKind(ticket.ticket_kind)).length;
  }

  const { data: orders, error: orderError } = await supabase
    .from("payment_orders")
    .select("id, status, selected_tickets")
    .eq("user_id", userId)
    .eq("event_id", eventId)
    .eq("status", "pending");

  if (orderError) throw orderError;

  const pendingCount = (orders || []).reduce(
    (sum, order) => sum + quantityFromSelectedTickets(order.selected_tickets),
    0
  );

  return {
    paidCount,
    pendingCount,
    remaining: Math.max(0, MAX_TICKETS_PER_ACCOUNT_PER_EVENT - paidCount - pendingCount),
  };
}
